// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3exad","title":"Images90_title__13Fb7","images":"Images90_images__VLH36"};